import {
    isValidElement,
    type ReactNode,
    cloneElement
} from "react";
import type {
    PopoverFooterDecorateConstantType,
    PopoverFooterChildPropsType
} from "./type";
import PopoverClose from "../close";

export const decoratePopoverFooterChild = ({
    borderRadius,
    stretchStyle,
    customTheme,
    isStretch,
    node,
    size
}: PopoverFooterDecorateConstantType): ReactNode => {
    if(!isValidElement<PopoverFooterChildPropsType>(node)) {
        return node;
    }

    if(node.type === PopoverClose) {
        return cloneElement(node, {
            children: decoratePopoverFooterChild({
                node: node.props.children,
                stretchStyle,
                borderRadius,
                customTheme,
                isStretch,
                size
            })
        });
    }

    return cloneElement(node, {
        borderRadius: node.props.borderRadius ?? borderRadius,
        customTheme: node.props.customTheme ?? customTheme,
        size: node.props.size ?? size,
        style: isStretch ? [
            node.props.style,
            stretchStyle
        ] : node.props.style
    });
};
